import React from 'react'
import {
  Grid,
  Header,
  Embed
} from "semantic-ui-react"
import HomeImage from '../../images/background.png'
import Screenshot from '../../images/screenshot.png'
import Image from "gatsby-image"
import { graphql, useStaticQuery } from "gatsby"

const Hero = () => {
    const data = useStaticQuery(graphql`
    query {
      app: file(relativePath: { eq: "app-store.png" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed
          }
        }
      },
      play: file(relativePath: { eq: "google-play.png" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed
          }
        }
      },
    }
  `)
    return (
      <section style={{backgroundColor: "#242424"}}>
        <div style={{
            paddingTop: '4em',
            paddingBottom: '4em',
            backgroundImage: `url(${HomeImage})`,
            backgroundColor: '#151515',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
        }}>
          <Grid stackable centered>
              <Grid.Row>
                  <Grid.Column width={8} verticalAlign={'middle'} textAlign={'center'}>
                      <Embed
                          id='G_q-xH3cRH8'
                          source='youtube'
                          placeholder={Screenshot}
                          autoplay
                      />
                    <Header
                      size={'huge'}
                      inverted
                      content={'Art Master'}
                      subheader={"The ultimate mobile game for art enthusiasts around the world."}
                    />
                    <p style={{color: 'white'}}>From incredible paintings by Jean-Michel Basquiat and Claude Monet to sculptures by Louise Nevelson and Auguste Rodin, Art Master is the ultimate game for art world enthusiasts.</p>
                    <p style={{color: 'white'}}>Pick a category that fits your expertise, whether it be Contemporary Art, Old Masters,
                        Modern Art, Impressionists, or Urban Art. Once selected, you are shown a set of
                        questions asking if you can identify the piece of art created by the artist in question.
                        If you can, then you'll earn points and badges to help prove yourself on the Art Master
                        leader board. If you can not, then you'll have the opportunity to educate yourself on the
                        artist by reading detailed biographies and viewing high-quality images of their
                        masterpieces around the world.</p>
                      <Header
                          size={'medium'}
                          inverted
                          content={'Available On'}
                      />
                      <div>
                          <a href='https://apps.apple.com/us/app/art-master/id1501260152' target='_blank' rel='noopener noreferrer'>
                              <Image
                                  fixed={data.app.childImageSharp.fixed}
                                  alt="App Store button to download iOS application."
                              />
                          </a>
                          <a href='https://play.google.com/store/apps/details?id=io.artcollection.art_quiz&hl=en_US' target='_blank' rel='noopener noreferrer'>
                              <Image
                                  fixed={data.play.childImageSharp.fixed}
                                  alt="Google Play Button to download Android application."
                              />
                          </a>
                      </div>
                  </Grid.Column>
              </Grid.Row>
          </Grid>
        </div>
      </section>
    )
};
export default Hero

